import React from 'react';
import ServiceForm from './ServiceManagementDialog';

const ServiceManagementDialog = (props) => {
  return <ServiceForm {...props} />;
};
export default ServiceManagementDialog;
